import { useState, useEffect } from 'react';

interface UseSplineTransitionReturn {
  showSecondSpline: boolean;
  handleFirstSplineLoad: VoidFunction;
}

const FIRST_VISIT_KEY = 'isQuantaVisited';

export const useSplineTransition = (delay: number = 12000): UseSplineTransitionReturn => {
  const [showSecondSpline, setShowSecondSpline] = useState<boolean>(false);

  useEffect(() => {
    const hasVisited = localStorage.getItem(FIRST_VISIT_KEY);

    if (hasVisited) {
      setShowSecondSpline(true);
    }
  }, []);

  const handleFirstSplineLoad = () => {
    setTimeout(() => {
      localStorage.setItem(FIRST_VISIT_KEY, 'true');

      setShowSecondSpline(true);
    }, delay);
  };

  return {
    showSecondSpline,
    handleFirstSplineLoad,
  };
};
